import "./RadioGroupComp.css";
import { defineComponent as c, resolveComponent as a, openBlock as t, createElementBlock as p, createVNode as _, normalizeClass as r, withCtx as s, Fragment as m, renderList as f, createBlock as G, createElementVNode as n, renderSlot as v, toDisplayString as h } from "vue";
import { SelectGroupComp as b } from "./SelectGroupComp.js";
import { SelectGroupOptionComp as y } from "./SelectGroupOptionComp.js";
import { _ as V } from "./_plugin-vue_export-helper.dad06003.js";
const g = c({
  events: {
    "update:modelValue": {
      type: Object
    }
  },
  components: {
    SelectGroupComp: b,
    SelectGroupOptionComp: y
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    selectedOption: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
});
const z = { class: "radioGroup" };
function C(e, l, $, O, k, B) {
  const d = a("select-group-option-comp"), i = a("select-group-comp");
  return t(), p("div", z, [
    _(i, {
      class: r({ radioGroup__horizontal: e.horizontal, radioGroup__vertical: !e.horizontal }),
      modelValue: e.selectedOption,
      "onUpdate:modelValue": l[0] || (l[0] = (o) => e.selectedOption = o),
      horizontal: e.horizontal
    }, {
      default: s(() => [
        (t(!0), p(m, null, f(e.options, (o) => (t(), G(d, {
          key: `${o.text}-${o.value}`,
          value: o,
          class: r({
            radioGroup__option: !0,
            "radioGroup__option--disabled": o.disabled
          })
        }, {
          default: s(({ isSelected: u }) => [
            n("div", {
              class: r({
                radioGroup__circle: !0,
                "radioGroup__circle--selected": u,
                "radioGroup__circle--disabled": o.disabled
              })
            }, null, 2),
            v(e.$slots, "label", { option: o }, () => [
              n("p", null, h(o.text), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["value", "class"]))), 128))
      ]),
      _: 3
    }, 8, ["class", "modelValue", "horizontal"])
  ]);
}
const q = /* @__PURE__ */ V(g, [["render", C], ["__scopeId", "data-v-c5635ceb"]]);
export {
  q as RadioGroupComp
};
//# sourceMappingURL=RadioGroupComp.js.map
